import { PermissionTarget } from "../Auth/permissionTargets.js"

/** The permission to edit the entity an import writes to, by GraphQL type. */
export const PERSON_CREDITS_IMPORT_ENTITY_PERMISSIONS = {
	Movie: PermissionTarget.MOVIE,
	Series: PermissionTarget.SERIES,
	SeriesSeason: PermissionTarget.SERIES,
	SeriesEpisode: PermissionTarget.SERIES,
} as const satisfies Record<string, PermissionTarget>
